import {
  ActionFunction,
  Form,
  Link,
  redirect,
  useActionData,
  useTransition,
} from "remix";
import {
  Button,
  FormButtonContainer,
  FormFieldContainer,
  Main,
} from "~/components";
import {
  commitSession,
  getSession,
  loginSchema,
  supabase,
  yupValidator,
} from "~/utils";

export const action: ActionFunction = async ({ request }) => {
  // get form
  const form = await request.formData();

  try {
    const formData = await yupValidator(form, loginSchema);

    const { email, password } = formData;

    const {
      session: sessionData,
      user,
      error: loginError,
    } = await supabase.auth.signIn({ email, password });

    if (!loginError) {
      let session = await getSession(request.headers.get("Cookie"));
      session.set("access_token", sessionData?.access_token);
      session.set("userId", user?.id);

      if (user?.user_metadata.type === "school") {
        return redirect("/dashboard/user/school", {
          headers: {
            "Set-cookie": await commitSession(session),
          },
        });
      }
      if (user?.user_metadata.type === "teacher") {
        return redirect("/dashboard/user/teacher", {
          headers: {
            "Set-cookie": await commitSession(session),
          },
        });
      }
      if (user?.user_metadata.type === "student") {
        return redirect("/dashboard/user/student", {
          headers: {
            "Set-cookie": await commitSession(session),
          },
        });
      }

      if (user?.user_metadata.type === "admin") {
        return redirect("/dashboard/admin", {
          headers: {
            "Set-cookie": await commitSession(session),
          },
        });
      }
    }
    return { error: loginError?.message };
  } catch (errors) {
    return { errors };
  }
};

export default function SignIn() {
  const actionData = useActionData();
  const transition = useTransition();
  return (
    <Main>
      <div>
        <h1>Login to your account</h1>
      </div>
      <Form method="post" noValidate>
        <FormFieldContainer>
          <label htmlFor="email">Email</label>
          <div>
            <input
              type="email"
              name="email"
              className="w-full border-gray-300 rounded-lg shadow-sm "
              id="email"
            />
            {actionData?.errors?.email && (
              <span className="text-red-600">{actionData?.errors?.email}</span>
            )}
          </div>
        </FormFieldContainer>

        <FormFieldContainer>
          <label htmlFor="password">Password</label>
          <div>
            <input
              type="password"
              name="password"
              className="w-full border-gray-300 rounded-lg shadow-sm "
              id="password"
            />
            {actionData?.errors?.password && (
              <span className="text-red-600">
                {actionData?.errors?.password}
              </span>
            )}
          </div>
        </FormFieldContainer>
        <FormButtonContainer>
          {transition.submission ? (
            <Button text="Processing..." />
          ) : (
            <Button text="Login" />
          )}
        </FormButtonContainer>
        <Link to="/account/forgot-password">Forgot password?</Link>
        {actionData?.error && (
          <span className="text-red-600">{actionData?.error}</span>
        )}
      </Form>
    </Main>
  );
}

